module.exports = __webpack_public_path__ + "img/img-es-usd.0ab5cae5.png";